import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectWebp } from "../features/ui/uiSlice";
import useWindowWidth from "./useWindowWidth";

export default function useImagesSrc() {
  const isSelectWebp = useSelector(selectWebp);
  const windowWidth = useWindowWidth();

  const getInitImagesSources = () => {
    if (windowWidth > 430 && isSelectWebp) {
      return {
        welcome: "../assets/Welcome.webp",
        location: "../assets/options/Location.webp",
        placeAlerts: "../assets/options/PlaceAlerts.webp",
        findLoved: "../assets/options/FindLoved.webp",
        flightStatus: "../assets/options/FlightStatus.webp",
        emergencyAlert: "../assets/options/EmergencyAlert.webp",
      };
    } else if (windowWidth < 430 && isSelectWebp) {
      return {
        welcome: "../assets/mobile/Welcome.webp",
        location: "../assets/options/Location.webp",
        placeAlerts: "../assets/options/PlaceAlerts.webp",
        findLoved: "../assets/options/FindLoved.webp",
        flightStatus: "../assets/options/FlightStatus.webp",
        emergencyAlert: "../assets/options/EmergencyAlert.webp",
      };
    } else if (windowWidth > 430 && !isSelectWebp) {
      return {
        welcome: "../assets/Welcome.png",
        location: "../assets/options/Location.png",
        placeAlerts: "../assets/options/PlaceAlerts.png",
        findLoved: "../assets/options/FindLoved.png",
        flightStatus: "../assets/options/FlightStatus.png",
        emergencyAlert: "../assets/options/EmergencyAlert.png",
      };
    } else {
      return {
        welcome: "../assets/mobile/Welcome.png",
        location: "../assets/options/Location.png",
        placeAlerts: "../assets/options/PlaceAlerts.png",
        findLoved: "../assets/options/FindLoved.png",
        flightStatus: "../assets/options/FlightStatus.png",
        emergencyAlert: "../assets/options/EmergencyAlert.png",
      };
    }
  };

  const [imagesSources, setImagesSources] = useState(getInitImagesSources());

  useEffect(() => {
    const imagesSources = getInitImagesSources();
    setImagesSources(imagesSources);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    imagesSources,
  };
}
